import React from 'react'
import { Card, Switch } from 'antd'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const StyledCard = styled(Card)`
	margin-bottom: 1.5rem;

	@media (max-width: 768px) {
		margin-bottom: 1rem;
	}
`

const SwitchContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`

const ICPSigning = ({ icpSigning, onICPSigningChange }) => {
	return (
		<StyledCard title="Assinatura ICP">
			<SwitchContainer>
				<Switch checked={icpSigning} onChange={onICPSigningChange} />
				<span>Exigir certificados ICP Brasil dos signatários</span>
			</SwitchContainer>
		</StyledCard>
	)
}

export default ICPSigning

ICPSigning.propTypes = {
	icpSigning: PropTypes.bool,
	onICPSigningChange: PropTypes.func.isRequired,
}
